import { getPluginSlots } from '@/plugin/slots'
import {
  DashboardSectionSkeleton,
  DashboardStatsSkeleton,
} from '@/components/dashboard/dashboard-section-skeleton'
import { CANDIDATE_KPI_GRID } from '@/components/dashboard/dashboard-metric-grid-classes'
import { Card } from '@/components/ui/card'
import { PageContainer } from '@/components/ui/page-container'

export type DashboardPageSkeletonFocus = 'candidate' | 'employer' | 'generic'

/** Full dashboard page placeholder while focus or section data is loading. */
export function DashboardPageSkeleton({
  focus = 'generic',
}: {
  focus?: DashboardPageSkeletonFocus
}) {
  if (focus === 'candidate') {
    return (
      <PageContainer aria-busy="true" aria-label="Loading dashboard">
        {getPluginSlots().candidateSectionsSkeleton ? (
          <Card className="bg-transparent">
            <DashboardStatsSkeleton
              count={5}
              variant="plain"
              layoutClassName={CANDIDATE_KPI_GRID}
            />
          </Card>
        ) : (
          <DashboardStatsSkeleton count={4} />
        )}
        {getPluginSlots().candidateSectionsSkeleton ? <DashboardSectionSkeleton cards={2} /> : null}
      </PageContainer>
    )
  }

  if (focus === 'employer') {
    return (
      <PageContainer aria-busy="true" aria-label="Loading dashboard">
        <DashboardStatsSkeleton count={2} columns={2} />
        {getPluginSlots().employerSectionsSkeleton ? (
          <DashboardSectionSkeleton cards={4} grid />
        ) : null}
      </PageContainer>
    )
  }

  return (
    <PageContainer aria-busy="true" aria-label="Loading dashboard">
      <DashboardStatsSkeleton count={2} columns={2} />
      <DashboardSectionSkeleton cards={2} />
    </PageContainer>
  )
}
